<template>
  <div ref="page" class="job-apply">
    <div class="job-header">
      <div>
        <h3>{{ $route.query.Name }}</h3>
        <p>{{ $route.query.Type }} | {{ $route.query.WorkPlace }}</p>
      </div>
      <div v-if="WechatUrl" class="wechat-qr">
        <vue-qr
          :text="WechatUrl"
          :logoSrc="wechatIconUrl"
          :logoScale="0.2"
          :size="80"
          :margin="0"
        ></vue-qr>
        <div class="wechat-qr-note">微信咨询</div>
      </div>
    </div>
    <div class="apply-form">
      <div ref="formMain" class="form-main">
        <form-section ref="formSection0" label="申请信息" anchor="anchor1">
          <form-item label="了解渠道">
            <el-input
              v-model="form.Source"
              size="default"
              placeholder="了解渠道"
              maxlength="50"
            ></el-input>
          </form-item>
        </form-section>
        <form-section ref="formSection1" label="上传" anchor="anchor2">
          <form-item label="上传简历" class="full-row">
            <upload-file
              v-model="form.CVFile"
              label="上传简历"
              accept="application/pdf,application/msword,application/vnd.ms-powerpoint,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.openxmlformats-officedocument.presentationml.presentation,application/vnd.ms-works,image/jpeg,image/png,text/plain"
              tips="支持pdf、doc、ppt、docx、pptx、wps、jpg、jpeg、png、txt等格式简历，不超过50MB"
            />
          </form-item>
          <form-item label="上传附件" :required="false" class="full-row">
            <upload-file
              v-model="form.AttachmentFile"
              label="上传附件"
              tips="支持文档、图片、压缩包、视频、音频、设计文件等格式文件，不超过50MB"
            />
          </form-item>
        </form-section>
        <form-section
          ref="formSection2"
          label="个人信息"
          anchor="anchor3"
          inline
        >
          <form-item label="姓名">
            <el-input
              v-model="form.Name"
              size="default"
              placeholder="姓名"
              maxlength="30"
            ></el-input>
          </form-item>
          <form-item label="手机号码">
            <el-input
              v-model="form.Phone"
              size="default"
              placeholder="手机号码"
              maxlength="20"
            ></el-input>
          </form-item>
          <form-item label="邮箱">
            <el-input
              v-model="form.Email"
              type="email"
              size="default"
              placeholder="邮箱"
              maxlength="100"
            ></el-input>
          </form-item>
          <form-item label="性别">
            <el-select v-model="form.Sex" size="default">
              <el-option value="男">男</el-option>
              <el-option value="女">女</el-option>
            </el-select>
          </form-item>
          <form-item label="出生年月(年龄)">
            <el-date-picker
              v-model="form.Birthday"
              value-format="yyyy-MM"
              size="default"
              type="month"
              :picker-options="birthdayPickerOptions"
              :default-value="birthdayDefaultValue"
              :placeholder="birthdayPlaceHolder"
            >
            </el-date-picker>
          </form-item>
          <form-item label="英语能力">
            <el-select v-model="form.EnglishLevel" size="default">
              <el-option
                v-for="item in englishLevel"
                :key="item"
                :value="item"
                >{{ item }}</el-option
              >
            </el-select>
          </form-item>
        </form-section>
        <form-section
          ref="formSection3"
          label="教育背景"
          anchor="anchor4"
          inline
        >
          <form-item label="就读时间" class="full-row">
            <year-month-range
              v-model="form.StudyingTime"
              :yearRange="yearRange"
            ></year-month-range>
          </form-item>
          <form-item label="学校名称">
            <el-input
              v-model="form.School"
              size="default"
              placeholder="学校名称"
              maxlength="100"
            ></el-input>
          </form-item>
          <form-item label="专业名称">
            <el-input
              v-model="form.Subjects"
              size="default"
              placeholder="专业名称"
              maxlength="100"
            ></el-input>
          </form-item>
          <form-item label="最高学历">
            <el-select v-model="form.Education" size="default">
              <el-option
                v-for="item in educationLevel"
                :key="item"
                :value="item"
                >{{ item }}</el-option
              >
            </el-select>
          </form-item>
          <form-item label="学位">
            <el-select v-model="form.Degree" size="default">
              <el-option
                v-for="item in degreeLevel"
                :key="item"
                :value="item"
                >{{ item }}</el-option
              >
            </el-select>
          </form-item>
          <form-item label="学校所在地">
            <el-select v-model="form.SchoolProvince" size="default">
              <el-option v-for="item in provinces" :key="item" :value="item">{{
                item
              }}</el-option>
            </el-select>
          </form-item>
        </form-section>
        <form-section ref="formSection4" label="其他" anchor="anchor5" inline>
          <form-item label="是否有亲属/朋友在本公司工作" class="full-row">
            <el-select
              v-model="form.HasFriend"
              @change="hasFriendChange"
              size="default"
            >
              <el-option value="是">是</el-option>
              <el-option value="否">否</el-option>
            </el-select>
          </form-item>
          <form-item v-if="form.HasFriend == '是'" label="亲朋姓名">
            <el-input
              v-model="form.FriendName"
              size="default"
              placeholder="亲朋姓名"
              maxlength="30"
            ></el-input>
          </form-item>
          <form-item v-if="form.HasFriend == '是'" label="关系">
            <el-select v-model="form.Relation" size="default">
              <el-option
                v-for="item in relationLevel"
                :key="item"
                :value="item"
                >{{ item }}</el-option
              >
            </el-select>
          </form-item>
          <form-item label="声明" class="full-row">
            <label class="solemnly-state">
              以上所填内容均为真实信息，本人愿意接受公司背景调查；如有不实，本人将无条件接受解雇并承担因此给公司造成的一切损失。
            </label>
            <el-checkbox v-model="form.Promised">本人承诺</el-checkbox>
          </form-item>
        </form-section>
        <div class="submit-wrap">
          <el-button
            type="primary"
            size="default"
            :loading="isSubmit"
            @click="submit"
            >提交</el-button
          >
        </div>
      </div>
      <form-anchor
        ref="formAnchor"
        :style="'transform: translateY(' + formAnchorTranslateY + 'px);'"
        :anchors="anchors"
        v-model="activeAnchor"
        @select-anchor="selectAnchor"
      ></form-anchor>
    </div>
  </div>
</template>
<script>
import AsyncValidator from 'async-validator'
import moment from 'moment'
import VueQr from 'vue-qr'
import wechatIconUrl from '../assets/images/wechatIcon.png'
export default {
  name: 'job-apply',
  components: { VueQr },
  data() {
    // 求职者的年龄要求：18到50岁
    var birthdayRange = [
      new Date(moment().subtract(50, 'year').format('YYYY-MM')),
      new Date(moment().subtract(18, 'year').format('YYYY-MM'))
    ]
    // 默认求职者为3年工作经验(6岁开始上学，22岁就业)
    var sampleBirthday = moment().subtract(22, 'year').format('YYYY-MM')
    var birthdayDefaultValue = new Date(sampleBirthday)
    var birthdayPlaceHolder = `年龄限18-50岁，可手动输入，示例：${sampleBirthday}`
    // 就读时间范围
    var minYear = moment().subtract(50, 'year').format('YYYY')
    var maxYear = moment().add(1, 'year').format('YYYY')
    console.log(maxYear)
    var yearRange = [parseInt(minYear), parseInt(maxYear)]
    return {
      wechatIconUrl: wechatIconUrl,
      birthdayPlaceHolder: birthdayPlaceHolder,
      birthdayDefaultValue: birthdayDefaultValue,
      birthdayPickerOptions: {
        disabledDate: (time) => {
          return time < birthdayRange[0] || time > birthdayRange[1]
        }
      },
      yearRange: yearRange,
      formAnchorTranslateY: 0,
      anchors: [
        { label: '申请信息', value: 'formSection0' },
        { label: '上传', value: 'formSection1' },
        { label: '个人信息', value: 'formSection2' },
        { label: '教育背景', value: 'formSection3' },
        { label: '其他', value: 'formSection4' }
      ],
      activeAnchor: '',
      isSetParentScrollTop: false,
      englishLevel: ['无', 'CET4', 'CET6', 'TEM4', 'TEM8', '其他'],
      educationLevel: [
        '本科',
        '硕士',
        '博士',
        '高中',
        '中专',
        '大专',
        'MBA',
        '其他'
      ],
      degreeLevel: ['无', '学士', '双学士', '硕士', '博士', 'MBA', '其他'],
      relationLevel: ['直系亲属', '旁系亲属', '朋友', '前同事', '其他'],
      provinces: [
        '北京',
        '上海',
        '天津',
        '重庆',
        '黑龙江',
        '吉林',
        '辽宁',
        '内蒙古',
        '河北',
        '新疆',
        '甘肃',
        '青海',
        '陕西',
        '宁夏',
        '河南',
        '山东',
        '山西',
        '安徽',
        '湖北',
        '湖南',
        '江苏',
        '四川',
        '贵州',
        '云南',
        '广西',
        '西藏',
        '浙江',
        '江西',
        '广东',
        '福建',
        '台湾',
        '海南',
        '香港',
        '澳门',
        '其他'
      ],
      form: {
        Source: '',
        CVFile: null,
        AttachmentFile: null,
        Name: '',
        Sex: '',
        Phone: '',
        Email: '',
        Birthday: '',
        EnglishLevel: '',
        StudyingTime: '',
        Education: '',
        EducationForm: '', //学历获得形式
        School: '', //学校
        Subjects: '', //专业
        Degree: '',
        Nation: '', //民族
        HasFriend: '',
        FriendName: '',
        Relation: '',
        Promised: '',
        SchoolProvince: ''
      },
      formRule: new AsyncValidator({
        Source: { required: true, message: '请输入了解渠道' },
        CVFile: { required: true, type: 'object', message: '请选择要上传简历' },
        Name: { required: true, message: '请输入姓名' },
        Sex: { required: true, message: '请选择性别' },
        Phone: [
          { required: true, message: '请输入手机号码' },
          {
            validator(rule, value, callback, source, options) {
              const errors = []
              if (!/1[3-9][0-9]{9}/.test(value)) {
                errors.push({ message: '手机号输入不正确' })
              }
              return errors
            }
          }
        ],
        Email: [
          { required: true, message: '请输入邮箱地址' },
          { type: 'email', message: '邮箱地址输入不正确' }
        ],
        Birthday: { required: true, message: '请选择出生年月' },
        EnglishLevel: { required: true, message: '请选择英语能力' },
        StudyingTime: [
          { required: true, message: '请选择就读时间' },
          {
            validator(rule, value, callback, source, options) {
              const errors = []
              var dates = value.split('/')
              if (moment(dates[0], 'YYYY-MM') >= moment(dates[1], 'YYYY-MM')) {
                errors.push({ message: '就读时间选择不正确' })
              }
              return errors
            }
          }
        ],
        School: { required: true, message: '请输入学校名称' },
        Subjects: { required: true, message: '请输入专业名称' },
        Education: { required: true, message: '请选择最高学历' },
        Degree: { required: true, message: '请选择学位' },
        SchoolProvince: { required: true, message: '请选择学校所在地' },
        HasFriend: {
          required: true,
          message: '请选择是否有亲属/朋友在本公司工作'
        },
        FriendName: {
          validator(rule, value, callback, source, options) {
            const errors = []
            if (source.HasFriend == '是' && !value) {
              errors.push({ message: '请输入亲朋姓名' })
            }
            return errors
          }
        },
        Relation: {
          validator(rule, value, callback, source, options) {
            const errors = []
            if (source.HasFriend == '是' && !value) {
              errors.push({ message: '请选择与亲朋的关系' })
            }
            return errors
          }
        },
        Promised: {
          validator(rule, value, callback, source, options) {
            const errors = []
            if (!value) {
              errors.push({ message: '必须勾选“本人承诺”才能提交' })
            }
            return errors
          }
        }
      }),
      isSubmit: false
    }
  },
  computed: {
    WechatUrl() {
      return this.$route.query.WechatUrl
    }
  },
  mounted() {
    this.setIframeHeight()
    this.setParentScrollTop(0) //回到顶部
    this.scroll()
    window.addEventListener('message', this.message)

    //恢复未提交的表单
    setTimeout(() => {
      var localFormCache = this.getLocalFormCache()
      if (
        localFormCache != null &&
        confirm('检测到上次未提交的表单，是否恢复？')
      ) {
        this.restoreLocalFormCache(localFormCache)
      } else {
        this.clearLocalFormCache()
      }
    }, 1000)
  },
  destroyed() {
    window.removeEventListener('message', this.message)
  },
  methods: {
    getLocalFormCache() {
      var localFormCache = localStorage.getItem('localFormCache')
      if (localFormCache) {
        return JSON.parse(localFormCache)
      }
      return null
    },
    restoreLocalFormCache(localFormCache) {
      for (var key in localFormCache) {
        if (localFormCache[key]) {
          this.$set(this.form, key, localFormCache[key])
        }
      }
      this.setIframeHeight()
    },
    setLocalFormCache(localFormCache) {
      localStorage.setItem('localFormCache', JSON.stringify(localFormCache))
    },
    clearLocalFormCache() {
      localStorage.removeItem('localFormCache')
    },
    message(e) {
      if (e.data && e.data.event && typeof this[e.data.event] == 'function') {
        this[e.data.event].apply(this, e.data.args)
      }
    },
    scroll(scrollTop) {
      var offsetScrollTop = scrollTop - 170
      if (offsetScrollTop > 0) {
        //最大位移
        var maxTranslateY =
          this.$refs.formMain.clientHeight -
          this.$refs.formAnchor.$el.clientHeight
        if (maxTranslateY < offsetScrollTop) {
          this.formAnchorTranslateY = maxTranslateY
        } else {
          this.formAnchorTranslateY = offsetScrollTop
        }
      } else {
        this.formAnchorTranslateY = 0
      }
      this.calcAnchor(scrollTop)
    },
    calcAnchor(scrollTop) {
      if (this.isSetParentScrollTop) {
        this.isSetParentScrollTop = false
        return
      }
      var offsetScrollTop = scrollTop - 150
      var resultAnchor = 'formSection0'
      for (var anchor of this.anchors) {
        if (offsetScrollTop - this.$refs[anchor.value].$el.offsetTop > 0) {
          //取最后一个anchor
          resultAnchor = anchor.value
        }
      }
      this.activeAnchor = resultAnchor
    },
    setIframeHeight() {
      this.$nextTick(() => {
        window.parent.postMessage(
          {
            callback: 'setIframeHeight',
            args: [this.$refs.page.scrollHeight + 50]
          },
          '*'
        )
      })
    },
    setParentScrollTop(scrollTop) {
      this.isSetParentScrollTop = true
      window.parent.postMessage(
        {
          callback: 'setScrollTop',
          args: [scrollTop]
        },
        '*'
      )
    },
    selectAnchor(anchor) {
      this.setParentScrollTop(this.$refs[anchor.value].$el.offsetTop + 200)
    },
    hasFriendChange() {
      this.setIframeHeight()
    },
    submit() {
      this.formRule
        .validate(this.form)
        .then((flag) => {
          this.doSubmit()
        })
        .catch(({ errors, fields }) => {
          if (errors.length > 0) {
            alert(errors[0].message)
          }
        })
    },
    doSubmit() {
      this.isSubmit = true
      var formData = new FormData()
      formData.append('JobId', this.$route.query.jobid)
      formData.append('HiringType', 'school')
      for (var key in this.form) {
        if (this.form[key]) {
          formData.append(key, this.form[key])
        }
      }
      this.$apiPost('/recruit/submit', formData)
        .then((data) => {
          this.isSubmit = false
          this.clearLocalFormCache()
          this.$router.replace('SubmitSuccess')
        })
        .catch((error) => {
          this.isSubmit = false
          alert('提交失败')
        })
    }
  },
  watch: {
    form: {
      deep: true,
      handler(newVal) {
        clearTimeout(this.formChaceDebounced)
        this.localFormCacheDebounced = setTimeout(() => {
          var localForm = {}
          for (var key in newVal) {
            //排除文件
            if (['CVFile', 'AttachmentFile'].indexOf(key) < 0) {
              localForm[key] = newVal[key]
            }
          }
          this.setLocalFormCache(localForm)
        }, 500)
      }
    }
  }
}
</script>
<style lang="less">
.job-apply {
  background-color: #fff;
  padding-top: 4%;
  .job-header {
    text-align: center;
    margin-bottom: 12%;
    display: flex;
    justify-content: left;
    h3 {
      margin: 0 0 4px;
      font-size: 22px;
      color: #1b1b1b;
    }
    p {
      font-size: 13px;
      margin: 0;
      color: #646464;
    }
    .wechat-qr {
      padding-top: 4%;
      margin-left: 20%;
      .wechat-qr-note {
        margin: 0;
        padding: 0;
        text-align: center;
      }
    }
  }
  .apply-form {
    padding: 2% 5%;
    box-sizing: border-box;
    .form-main {
      width: 100%;
      .el-input {
        .el-input__inner {
          border-radius: 0;
        }
        &.el-date-editor {
          width: 100%;
        }
      }
      .el-select {
        width: 100%;
        .el-input__icon {
          cursor: default;
        }
      }
      .solemnly-state {
        font-size: 14px;
        color: #646464;
        margin-bottom: 12px;
        display: block;
      }
      .submit-wrap {
        text-align: center;
        margin-bottom: 12px;
        .el-button {
          padding-left: 35px;
          padding-right: 35px;
        }
      }
    }

    .form-anchor {
      display: none;
    }
  }
}
@media (min-width: 768px) {
  .job-apply {
    .job-header {
      border-bottom: 1px solid #cbcbcc;
      padding: 3%;
      text-align: left;
      margin-bottom: 0;
      h3 {
        margin: 0 0 10px;
        font-size: 32px;
        color: #1b1b1b;
      }
      p {
        font-size: 16px;
        margin: 0;
        color: #646464;
      }
    }
    .apply-form {
      padding: 3%;
      position: relative;
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      .form-main {
        width: 72.5%;
        .form-item {
          width: 46.6%;
          &.full-row {
            width: 100%;
          }
        }
        .el-input {
          .el-input__inner {
            border-radius: 0;
          }
        }
        .el-select {
          width: 100%;
        }
        .upload-file {
          .select-file-btn,
          .select-file-warp {
            width: 46.6%;
          }
        }
        .solemnly-state {
          font-size: 16px;
          margin-bottom: 14px;
        }
        .submit-wrap {
          margin-bottom: 14px;
        }
      }

      .form-anchor {
        display: block;
        width: 21%;
      }
    }
  }
}
</style>
